import { atom } from 'jotai'

import { type Survey } from '~/gql/graphql'
import { type SurveyGroupFilterGroups } from '~/utils'

import { auth0UserAtom } from './auth0UserAtom'
import { createAtomWithLocalStorage } from './utils'

const surveyGroupIdAtom = atom('')

export const surveyGroupFilterKeyAtom = atom(
  (get) => {
    const auth0User = get(auth0UserAtom)
    const surveyGroupId = get(surveyGroupIdAtom)

    return [
      'analyzer',
      'surveyGroup',
      surveyGroupId,
      auth0User?.sub,
      'surveyGroupFilter',
    ].join('::')
  },
  (_get, set, surveyGroupId: string | undefined) => {
    set(surveyGroupIdAtom, surveyGroupId ?? '')
  },
)

export const surveyGroupFilterAtom = createAtomWithLocalStorage<{
  countMap: Record<Survey['id'], number>
  filterGroups: SurveyGroupFilterGroups
}>((get) => get(surveyGroupFilterKeyAtom))
